module.exports = __webpack_public_path__ + "img/banner.44317a3f.jpg";